export default function isDelfiPhoneNumber(number) {
    return false
    //const _phoneNumber = String(number)
    //_phoneNumber.startsWith('+370') || _phoneNumber.startsWith('+371')
}
